@if (hasInitialised) {
  <form
    [formGroup]="form"
    (ngSubmit)="saveFirmDetails()"
    >
    <div class="container">
      <formly-form
        [model]="model"
        [form]="form"
        [fields]="fields"
        />
      @if (showSave()) {
        <div
          class="d-flex justify-content-end my-3"
          >
          <button
            type="submit"
            class="btn btn-colour-blue-600"
            >
            Save firm details
          </button>
        </div>
      }
    </div>
  </form>
}
